import { SelectProps } from '@amzn/awsui-components-core/select';
import { useEffect, useState } from 'react';
import { AppLogoService } from 'src/services/AppLogoService';
import { BUNDLED_LOGO_OPTIONS } from './LogoLibraryConstants';

/**
 * Returns the full logo options list including bundled icons and shared library logos.
 * Shared logos are fetched from S3 on mount and appended as a third option group.
 */
export const useLogoOptions = (): SelectProps.OptionGroup[] => {
  const [options, setOptions] = useState<SelectProps.OptionGroup[]>(BUNDLED_LOGO_OPTIONS);

  useEffect(() => {
    let cancelled = false;

    AppLogoService.listSharedLogos()
      .then((items) => {
        if (cancelled || items.length === 0) return;

        const sharedGroup: SelectProps.OptionGroup = {
          label: 'Shared Library',
          options: items.map((item) => ({
            value: `shared:${item.filename}`,
            label: item.filename.replace(/\.[^.]+$/, ''),
            labelTag: 'Shared'
          }))
        };

        setOptions([sharedGroup, ...BUNDLED_LOGO_OPTIONS]);
      })
      .catch(() => {
        // Gracefully degrade — show only bundled options
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return options;
};
